module.exports = __webpack_public_path__ + "df63d21a74696de2998e9caa93ebad20.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-clown-s.png
// module id = 1923
// module chunks = 0